export const environment = {
  production: false,
  emailjs: {
    publicKey: 'oS30F7gUdd16Lkhxx',
    serviceId: 'service_94cybzf',
    templateComercial: 'template_xmmfuzq',
    templateTecnico: 'template_ckd0ye9'
  }
};
